import { render } from "./registrationStep3.vue?vue&type=template&id=1678641e&scoped=true"
import script from "./registrationStep3.vue?vue&type=script&lang=js"
export * from "./registrationStep3.vue?vue&type=script&lang=js"

import "./registrationStep3.vue?vue&type=style&index=0&id=1678641e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1678641e"]])

export default __exports__